import { createFileRoute } from "@tanstack/react-router";
import { CampaignLanding, type FaqItem } from "@/components/sections/CampaignLanding";

const URL = "https://kentro.com.br/google";
const TITLE = "Kentro Sistemas Inteligentes | Chat + CRM + IA para WhatsApp";
const DESC =
  "Atenda no WhatsApp, organize o CRM e venda mais com IA. Plataforma omnichannel com API Oficial do WhatsApp. Demonstração gratuita.";

const QUICK_BULLETS = [
  "API Oficial do WhatsApp — sem risco de bloqueio",
  "Implantação guiada em poucos dias",
  "Integra com seu ERP / CRM atual",
  "Suporte humano 24/7 + IA treinada",
  "LGPD e dados em servidor brasileiro",
  "Sem fidelidade, cancele quando quiser",
];

const FAQS: FaqItem[] = [
  {
    q: "Em quanto tempo a Kentro entra no ar?",
    a: "A maioria dos clientes começa a operar em poucos dias. Nosso time guia a integração com WhatsApp API Oficial, importação de contatos e treinamento da IA.",
  },
  {
    q: "Preciso trocar o número do meu WhatsApp?",
    a: "Não. Migramos seu número atual (comum ou business) para a API Oficial sem perder histórico nem contatos.",
  },
  {
    q: "A IA substitui meus atendentes?",
    a: "Não. A IA filtra dúvidas comuns, qualifica leads e responde 24/7. Quando o cliente precisa de um humano, ela faz o transbordo automático.",
  },
  {
    q: "A Kentro atende empresas pequenas?",
    a: "Sim. Temos planos para PMEs e operações que crescem rápido, com preço que cabe no orçamento e suporte de verdade.",
  },
  {
    q: "Quanto custa?",
    a: "O valor depende do volume e dos canais. Fale com um especialista pelo WhatsApp para uma proposta sob medida — a demonstração é gratuita.",
  },
];

export const Route = createFileRoute("/google")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: "Kentro: Chat + CRM + IA para WhatsApp" },
      {
        property: "og:description",
        content:
          "Centralize WhatsApp, Instagram e CRM em uma só plataforma com IA. Solicite uma demonstração gratuita.",
      },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify([
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Kentro Sistemas Inteligentes",
            url: "https://kentro.com.br",
            logo: "https://kentro.com.br/og-image.png",
            sameAs: [
              "https://www.linkedin.com/company/kentro-sistemas",
              "https://www.instagram.com/kentrosistemas",
              "https://www.youtube.com/@kentrosistemas",
            ],
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: "+55-0800-550-2020",
                contactType: "customer service",
                areaServed: "BR",
                availableLanguage: ["Portuguese"],
              },
              {
                "@type": "ContactPoint",
                telephone: "+55-11-91582-7716",
                contactType: "sales",
                areaServed: "BR",
                availableLanguage: ["Portuguese"],
              },
              {
                "@type": "ContactPoint",
                telephone: "+55-38-3220-8706",
                contactType: "sales",
                areaServed: "BR",
                availableLanguage: ["Portuguese"],
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: TITLE,
            description: DESC,
            url: URL,
            inLanguage: "pt-BR",
            isPartOf: {
              "@type": "WebSite",
              name: "Kentro Sistemas Inteligentes",
              url: "https://kentro.com.br",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQS.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          },
        ]),
      },
    ],
  }),
  component: GoogleLanding,
});

function GoogleLanding() {
  return (
    <>
      <CampaignLanding
        source="google"
        eyebrow="Plataforma omnichannel com IA"
        headline={
          <>
            Atenda, organize e venda mais no WhatsApp com{" "}
            <span className="gradient-text">Chat + CRM + IA</span>
          </>
        }
        subheadline="A Kentro Sistemas Inteligentes une atendimento omnichannel, CRM e IA treinada para o seu negócio em uma só plataforma — com API Oficial do WhatsApp."
        highlights={[
          "Reduza o tempo médio de resposta de horas para segundos.",
          "Centralize WhatsApp, Instagram, voz, e-mail e webchat em uma única tela.",
          "IA qualifica e responde 24/7, com transbordo humano automático.",
          "CRM com funil, histórico e automações que organizam o time comercial.",
          "Relatórios e BI para entender o que gera venda e o que trava.",
        ]}
        quickBullets={QUICK_BULLETS}
        faqs={FAQS}
        whatsappMessage="Olá! Vim pelo Google e quero saber mais."
      />
    </>
  );
}
